<template>
  
  <b-card style="border: 1px solid #0080C9;" class="mb-0">

    <div>
      <div class="d-flex">
         
        <h5 v-if="stEsDerivacion === '1'" style="width: 200px">Crear Contrareferencia?</h5>
        <h5 v-else style="width: 200px">Crear Derivariones?</h5>

        <b-form-checkbox 
          v-model="crearDerivaciones" 
          switch
          class="ml-2"
        >
          {{ crearDerivaciones ? 'Si' : 'No' }}
        </b-form-checkbox>
      </div>

      <div 
        v-if="crearDerivaciones && stEsDerivacion === '0'" 
        class="row my-1 align-items-end"
      >

        <div class="col-6">
          <label for="">Tipo Atencion</label>
          <v-select
            v-model="tempDerivacion.tipoAtencion"
            :options="tipoAtencionOpts"
            :reduce="option => option"
            label="text"
          />
        </div>
        

        <div class="col" v-if="showDerivacionesEspecialidad">
          <label for="">Especialidad</label>
          <v-select
            v-model="tempDerivacion.especialidad"
            :options="allEspecialidades"
            :reduce="option => option"
            label="text"
          />
        </div>
        

        <div class="col-1" v-if="showDerivacionesAdd">
          <b-button
            @click="addDerivacion"
            size="sm"
            variant="warning"
          >+</b-button>
        </div>
        
      </div>

      <b-alert 
        show 
        variant="info" 
        v-if="derivacionesList.length"
        class="p-2"
      >
        <div class="row" v-for="(derivacion, index) in derivacionesList" :key="derivacion.id">
          <!-- <div class="col">{{ derivacion  }}</div> -->
          <div class="col">{{index + 1}}</div>
          <div class="col-5">{{ derivacion.tipoAtencion.text  }}</div>
          <div class="col-5">{{ derivacion.especialidad ? derivacion.especialidad.text : '- - -'  }}</div>
          <div class="col"> 
            <b-button 
              size="sm" 
              variant="danger" 
              @click="removeDerivacion(index)"
            >X</b-button>
          </div>
          <hr class="col-11"/>
        </div>
      </b-alert>

      <b-alert
        v-if="showNoDerivaciones"
        show 
        variant="danger"
        class="text-center p-2"
      >
        Aun no ha agregado ninguna derivacion
      </b-alert>
     
    </div> 
    

    <hr class="my-2"/>

    <div v-if="stEsDerivacion === '0'">

      <div class="d-flex">
        <h5 style="width: 200px">Crear Interconsultas?</h5> 
        <b-form-checkbox 
          v-model="crearInterconsultas" 
          switch
          class="ml-2"
        >
          {{ crearInterconsultas ? 'Si' : 'No' }}
        </b-form-checkbox>
      </div>

      <div v-if="crearInterconsultas " class="row my-1">
        <div class="col">
          <v-select
            v-model="tempInterconsulta"
            :options="allEspecialidades"
            :reduce="option => option"
            
            label="text"
          />
        </div>

        <div class="col-1" v-if="tempInterconsulta">
          <b-button
            @click="addInterconsulta"
            size="sm"
            variant="warning"
          >+</b-button>
        </div>
        
      </div>

      <b-alert 
        show 
        variant="info" 
        v-if="interconsultasList.length"
        class="p-2"
      >
        <div class="row" v-for="(interconsulta, index) in interconsultasList" :key="interconsulta.value">
          <div class="col">{{index + 1}}</div>
          <div class="col-9">{{ interconsulta.text }}</div>
          <div class="col"> 
            <b-button 
              size="sm" 
              variant="danger" 
              @click="removeInterconsulta(index)"
            >X</b-button>
          </div>
          <hr class="col-11"/>
        </div>
      </b-alert>

      <b-alert
        v-if="showNoInterconsultas"
        show 
        variant="danger"
        class="text-center p-2"
      >
        Aun no ha agregado ninguna interconsulta
      </b-alert>
    </div>
    
  </b-card> 

  
</template>

<script>
import vSelect from "vue-select";
import { especialidadService } from "@/shared/services";
import { mapState } from "vuex";

export default {

  name: "CrearDerivacionesInterconsultas",

  components: {
    vSelect
  },

  data(){
    return{
      crearDerivaciones: false,
      crearInterconsultas: false,

      especialidadTemp: null,
      allEspecialidades: [],

      derivacionesList: [],
      interconsultasList: [],
      tempInterconsulta: null,

      tempDerivacion:{
        tipoAtencion: null,
        especialidad: null
      },


      stData:{
        derivaciones: [],
        interconsultas: []
      },

      tipoAtencion: null,

      tipoAtencionOpts: [
        { value: 1, text: "Consulta Externa" },
        { value: 2, text: "Laboratorio" },
        { value: 3, text: "Imagen" },
        { value: 4, text: "Procedimientos Diagnósticos" },
        { value: 5, text: "Hospitalización" },
        { value: 6, text: "Emergencia" },
        { value: 7, text: "Tratamiento Integral Oncologico" }
      ]
    }
  },

  async created(){
    this.allEspecialidades  = await especialidadService.getOptionsSelect();
  },


  methods: {

    addDerivacion(){

      // validar que no sea de la misma especialidad
      if(this.tempDerivacion.tipoAtencion.value === 1){
        const repetidasEspecialidadCrear = this.derivacionesList.find( d => d.especialidad?.value === this.tempDerivacion.especialidad?.value);
        const repetidasEspecialidadRegistradas = this.stDataRegistrada?.derivaciones.find( d => d.especialidad?.id === this.tempDerivacion.especialidad?.value);

        if(repetidasEspecialidadCrear || repetidasEspecialidadRegistradas){ 
          this.$swal({
            icon: "warning",
            title: "Advertencia",
            text: "No puede derivar 2 veces a la misma especialidad."
          });
          return
        }
      }

      // validar que no sea del mismo tipo
      // if(this.tempDerivacion.tipoAtencion.value !== 1){
      //   const repetidasTipoCrear = this.derivacionesList.find( d => d.tipoAtencion?.value === this.tempDerivacion.tipoAtencion?.value);
      //   const repetidasTipoRegistradas = this.stDataRegistrada?.derivaciones.find( d => d.tipoAtencion == this.tempDerivacion.tipoAtencion?.value);


      //   if(repetidasTipoCrear || repetidasTipoRegistradas){
      //     this.$swal({
      //       icon: "warning",
      //       title: "Advertencia",
      //       text: "No puede derivar 2 veces por el mismo tipo de atencion."
      //     });
      //     return
      //   }
      // }


      this.derivacionesList.push(this.tempDerivacion)
      this.tempDerivacion = {
        tipoAtencion: null,
        especialidad: null
      }
    },

    removeDerivacion(index){
      this.derivacionesList.splice(index, 1);
    },

    addInterconsulta(){
      if(!this.tempInterconsulta) return;

      const alreadyInList = this.interconsultasList.some(i => i.value === this.tempInterconsulta.value);
      const alreadyRegistrada = this.stDataRegistrada?.interconsultas?.some(i => i.especialidad?.id === this.tempInterconsulta.value);

      if(alreadyInList || alreadyRegistrada){
        this.$swal({
          icon: "warning",
          title: "Advertencia",
          text: "No enviar 2 interconsultas a la misma especialidad."
        });
        this.tempInterconsulta = null;
        return;
      }

      this.interconsultasList.push(this.tempInterconsulta);
      this.tempInterconsulta = null;
    },

    removeInterconsulta(index){
      this.interconsultasList.splice(index, 1);
    }
  },

  computed: {
    ...mapState({
      stEsDerivacion   : state => state.atencionCita.dataCita?.derivacion,
      stDataRegistrada : state => state.atencionCita?.derivacionesInterconsultas?.registradas
    }),


    showDerivacionesEspecialidad(){
      const tipoAtencion = this.tempDerivacion?.tipoAtencion?.value
      if(!tipoAtencion) return false;

      if([2, 3].includes(tipoAtencion)) return false;

      return true;
    },

    showDerivacionesAdd(){
      const tipoAtencion = this.tempDerivacion?.tipoAtencion?.value
      const especialidad = this.tempDerivacion?.especialidad
      if(!tipoAtencion) return false;

      if(![2, 3].includes(tipoAtencion)){
        if(!especialidad) return false;
      }

      return true;
    },

    showNoDerivaciones(){
      if(!this.crearDerivaciones) return false;
      if(this.derivacionesList.length > 0) return false;
      return true
    },

    showNoInterconsultas(){
      if(!this.crearInterconsultas) return false;
      if(this.interconsultasList.length > 0) return false;
      return true;
    }

  },

  watch:{


    'tempDerivacion.tipoAtencion':{
      deep: true,
      handler() {
        this.tempDerivacion.especialidad = null;
      }
    },

    crearDerivaciones:{
      deep: true,
      handler(newValue) {
        if (newValue && this.stEsDerivacion === '1') {
          this.derivacionesList = [{ 
            tipoAtencion: { value: "1", text: "Consulta Externa" },
            especialidad: { value: "1", text: "MEDICINA GENERAL (CE)", codigo: "0000000531" },
          }];
        } else {
          this.derivacionesList = []
        }
      }
    },

    derivacionesList:{
      deep: true,
      handler(newValue) {
        this.stData.derivaciones = newValue
      }
    },


    interconsultasList:{
      deep: true,
      handler(newValue) {

        if(!newValue.length){
          this.stData.interconsultas = [];
          return;
        }

        const interconsultasNuevas = [...newValue];
        const idsRegistrados = this.stDataRegistrada?.interconsultas?.map(d => d.especialidad?.id) || [];

        const noRepetidas = interconsultasNuevas.filter(
          nueva => !idsRegistrados.includes(nueva.value)
        );

        const repetidas = interconsultasNuevas.filter(
          nueva => idsRegistrados.includes(nueva.value)
        );

        if(repetidas.length){
          this.$swal({
            icon: "warning",
            title: "Advertencia",
            text: "No enviar 2 interconsultas a la misma especialidad."
          });

          this.interconsultasList = noRepetidas
        }

        this.stData.interconsultas = noRepetidas
      }
    },


    stData:{
      deep: true,
      handler(newValue) {
        this.$store.commit("setCrearDerivacionesInterconsultas", newValue);
      }
    }
  }
}
</script>
